export function downloadFile(file: Blob, filename: string): void {
  const downloadUrl = URL.createObjectURL(file);

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  link.remove();
  setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
}
